module.exports = {
	"ha": "viha",
	"id": 5.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 85.36585365853658,
						"dataLabels": {
							"enabled": true,
							"format": "35",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.04878048780488,
						"dataLabels": {
							"enabled": true,
							"format": "32",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.17073170731707,
						"dataLabels": {
							"enabled": true,
							"format": "30",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.85365853658537,
						"dataLabels": {
							"enabled": true,
							"format": "27",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 43.90243902439025,
						"dataLabels": {
							"enabled": true,
							"format": "18",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.47899159663865,
						"dataLabels": {
							"enabled": true,
							"format": "116",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": true,
							"format": "105",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.03361344537815,
						"dataLabels": {
							"enabled": true,
							"format": "100",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.15126050420169,
						"dataLabels": {
							"enabled": true,
							"format": "93",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 47.89915966386555,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.38709677419355,
						"dataLabels": {
							"enabled": true,
							"format": "183",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 97.31182795698925,
						"dataLabels": {
							"enabled": true,
							"format": "181",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 94.08602150537635,
						"dataLabels": {
							"enabled": true,
							"format": "175",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.40860215053763,
						"dataLabels": {
							"enabled": true,
							"format": "157",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.98924731182796,
						"dataLabels": {
							"enabled": true,
							"format": "106",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.43342036553526,
						"dataLabels": {
							"enabled": true,
							"format": "754",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 97.51958224543081,
						"dataLabels": {
							"enabled": true,
							"format": "747",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 94.7780678851175,
						"dataLabels": {
							"enabled": true,
							"format": "726",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.2088772845953,
						"dataLabels": {
							"enabled": true,
							"format": "691",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.01566579634465,
						"dataLabels": {
							"enabled": true,
							"format": "521",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -14.634146341463417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.571428571428575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5210084033613467,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.482758620689658,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.999999999999995,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -38.70967741935484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6129032258064502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -1.0928961748633892,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.314917127071826,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.285714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -32.484076433121025,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.5665796344647487,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -0.9283819628647216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.8112449799196804,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.820936639118456,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -24.60202604920405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=41"
			},
			{
				"x": 9,
				"text": "30–39<br>n=119"
			},
			{
				"x": 15,
				"text": "40–49<br>n=186"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=766"
			}
		],
		"dataTable": {
			"< 30": [
				41,
				35,
				32,
				30,
				27,
				18
			],
			"30–39": [
				119,
				116,
				105,
				100,
				93,
				57
			],
			"40–49": [
				186,
				183,
				181,
				175,
				157,
				106
			],
			"≥ 50": [
				766,
				754,
				747,
				726,
				691,
				521
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_3.json
// module id = 338
// module chunks = 0